function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, ref, watch, reactive, getCurrentInstance } from "vue";
import { addQueryString } from "@com/utils/url";
import BasicForm from "@/views/creative/model-editor/basic-form.vue";
import AppearanceForm from "@/views/creative/model-editor/appearance-form.vue";
import UpdateModelButton from "@/views/creative/model-editor/update-model-button.vue";
import { HSVValueType, ModelEditorProtocol, ModelEditorProtocolDataType } from "@/store/creative/model-editor/index.type";
import getTransformtypeByKey from "@/store/creative/model-editor/get-transformtype-by-key";
import useFileToExchangeResource from "@/views/creative/utils/use-file-to-exchange-resource";
import _ from "lodash";
import { getJsonModelPath, isAnimationPrefix, isTexturePrefix } from "@/views/creative/utils";
import isMaterialWarehouse from "@/common/is-warehouse";
import { updateMaterialListByConfig, getMaterialListByDefault, syncModelMaterialListToCategory } from "@/views/creative/utils/model-material-utils";
import AppearanceSkinDialog from "@/views/creative/model-editor/appearance-skin-dialog.vue";
import { TabType, useModelStore } from "@/views/creative/model-editor/model-mixin";
import { language } from "@/common/storage";
import AnimationForm from "./animation-form.vue";
import { getAnimationList, getAnimationOriginRotateByPath, getAnimationRotateDiff, syncModelAnimationListToTemplateCategory } from "@/views/creative/utils/model-animation-utils";
import { isFeModelId } from "@/store/creative/common/category";
import useIdToFindCategory from "@/views/creative/utils/use-id-to-find-category";
import { getCommonAssetModelInfo } from "@/api/common/asset";
import { isPresetPrefix } from "@/views/creative/utils/preset-utils";
export default defineComponent({
    components: {
        AppearanceSkinDialog: AppearanceSkinDialog,
        BasicForm: BasicForm,
        AppearanceForm: AppearanceForm,
        UpdateModelButton: UpdateModelButton,
        AnimationForm: AnimationForm
    },
    setup: function setup(props) {
        var postMessage = function postMessage(data) {
            if (iframeRef.value) {
                console.log("postMessage", data);
                iframeRef.value.contentWindow.postMessage({
                    type: ModelEditorProtocol,
                    data: data
                }, "*");
            }
        };
        var closeAnimationView = function closeAnimationView() {
            postMessage({
                type: ModelEditorProtocolDataType.moduleEnableEvent,
                data: {
                    key: "reference",
                    value: true
                }
            });
            postMessage({
                type: ModelEditorProtocolDataType.moduleEnableEvent,
                data: {
                    key: "animation",
                    value: false
                }
            });
        };
        var showAnimationView = function showAnimationView() {
            postMessage({
                type: ModelEditorProtocolDataType.moduleEnableEvent,
                data: {
                    key: "reference",
                    value: false
                }
            });
            postMessage({
                type: ModelEditorProtocolDataType.moduleEnableEvent,
                data: {
                    key: "animation",
                    value: true
                }
            });
        };
        var changeAnimationRotation = function changeAnimationRotation(value) {
            postMessage({
                type: ModelEditorProtocolDataType.transformType,
                data: {
                    transformType: "eulerAngles",
                    vectorKey: "y",
                    value: storeBasicModel.value.rotateY + value
                }
            });
        };
        var isPathInReplacementState = function isPathInReplacementState(path) {
            if (!replaceData.value || !replaceData.value.length) {
                return false;
            }
            var animationList = getAnimationList(category.value);
            var animation = animationList.find(function(item) {
                return item.file_path === path;
            });
            if (!animation) {
                return false;
            }
            var animationCategory = useIdToFindCategory({
                category: templateCategory.value,
                categoryId: animation.category_id
            });
            return replaceData.value.some(function(item) {
                return item.prefix === animationCategory.prefix;
            });
        };
        var getRotationDiffByPath = // 通过比较 category 以及 modelAnimationList 里面对应数据的 rotate 值，来获取当前动画的旋转角度的 diff 值
        function getRotationDiffByPath(path) {
            var target = modelAnimationList.value.find(function(item) {
                return item.file_path === path;
            });
            var originRotate = getAnimationOriginRotateByPath(category.value, path);
            if (isPathInReplacementState(path)) {
                originRotate = 0;
            }
            if (target) {
                return getAnimationRotateDiff(originRotate, target.rotate);
            }
            return 0;
        };
        var cookResource = function cookResource(file) {
            return useFileToExchangeResource({
                file: file,
                id: currentResource.value.id,
                category: category.value,
                isZip: true,
                isModel: true,
                isCocosModel: true
            });
        };
        var updateResource = // @ts-ignore
        function updateResource(param) {
            var file = param.file;
            var resource = cookResource(file);
            var currentMap = replaceMap.value[category.value.id];
            store.dispatch("creative/template/updateResource", _objectSpreadProps(_objectSpread({}, resource), {
                id: currentResource.value.id,
                res_id: currentMap && currentMap.resId,
                res_source: currentMap && currentMap.resSource || "common"
            }));
        };
        var submitCallback = function submitCallback() {
            dialogConfig.visible = false;
            activeTab.value = TabType.Basic;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var _$ref1 = useModelStore(store), category = _$ref1.category, materialId = _$ref1.materialId, modelId = _$ref1.modelId, animationId = _$ref1.animationId, resource1 = _$ref1.resource, hsvModel = _$ref1.hsvModel, storeBasicModel = _$ref1.storeBasicModel, shaderModel = _$ref1.shaderModel, targetModelMaterial = _$ref1.targetModelMaterial, modelMaterialList = _$ref1.modelMaterialList, materialPath = _$ref1.materialPath, cocosActionResourceList = _$ref1.cocosActionResourceList, textureResourceList = _$ref1.textureResourceList, modelAnimationList = _$ref1.modelAnimationList, animationPath = _$ref1.animationPath, animationModel = _$ref1.animationModel, templateCategory = _$ref1.templateCategory, replaceMap = _$ref1.replaceMap;
        var animationForm = ref(null);
        var activeTab = ref("");
        var submitLoading = ref(false);
        var iframeRef = ref();
        var visible = computed({
            get: function get() {
                return store.state.creative.modelEditor.visible;
            },
            set: function set(value) {
                store.commit("creative/modelEditor/hideModelEditor", value);
            }
        });
        // 每次打开编辑器时，将基本模型和HSV模型重置, 关闭的时候清除替换数据
        watch(function() {
            return store.state.creative.modelEditor.visible;
        }, function(value) {
            if (value) {
                submitLoading.value = false;
                store.dispatch("creative/modelEditor/resetModelEditorState", "open");
                store.commit("creative/modelEditor/setModelCategory", store.state.creative.template.currentCategory);
                store.dispatch("creative/modelEditor/syncCategoryPropertiesToStore", category.value);
                activeTab.value = TabType.Basic;
            } else {
                store.dispatch("creative/modelEditor/resetModelEditorState", "closed");
            }
        });
        var loading = computed(function() {
            return store.state.creative.modelEditor.loading;
        });
        var replaceData = computed(function() {
            return store.state.creative.modelEditor.replaceData;
        });
        var iframeUrl = computed(function() {
            // todo iframe 支持开关
            var previewParams = {
                model_preview: 1,
                model_path: store.state.creative.modelEditor.modelPath,
                disabled_preview_statistic: isMaterialWarehouse() ? 0 : 1,
                disabled_preview_animation: 1
            };
            if (replaceData.value.length) {
                previewParams.pre_replace = 1;
                previewParams.pre_data = replaceData.value.map(function(i) {
                    return JSON.stringify({
                        type: i.type,
                        key: i.key,
                        value: i.value
                    });
                });
            }
            if (store.state.creative.template.previewUrl) {
                return addQueryString(store.state.creative.template.previewUrl, previewParams).replace("loading=1", "loading=-1");
            }
            return "";
        });
        watch(function() {
            return animationPath.value;
        }, function(path) {
            // 每次切换动画之前 需要旋转角度
            if (path) {
                showAnimationView();
                changeAnimationRotation(getRotationDiffByPath(path));
            } else {
                changeAnimationRotation(0);
            }
            postMessage({
                type: ModelEditorProtocolDataType.playAnimation,
                data: {
                    path: path
                }
            });
        });
        watch(function() {
            return materialPath.value;
        }, function(path) {
            // 每次切换 材质之前 都保存数据
            store.commit("creative/modelEditor/updateLoading", true);
            store.dispatch("creative/modelEditor/syncStoreToModelModifyConfig");
            postMessage({
                type: ModelEditorProtocolDataType.setMaterial,
                data: {
                    path: path
                }
            });
        });
        // 监听动画数据变化，更新 modelAnimationList 以及驱动 iframe 更新
        watch(function() {
            return animationModel.value;
        }, function(newVal, oldVal) {
            if (newVal.id && !_.isEqual(newVal, oldVal)) {
                console.log("animationModel \u66F4\u65B0\u4E86", newVal);
                // 编辑的 id，非当前展示的 id 则不需要驱动 iframe 更新
                if (animationId.value !== newVal.id) return;
                if (newVal.speed && newVal.speed !== oldVal.speed) {
                    postMessage({
                        type: ModelEditorProtocolDataType.animationSpeedChangedEvent,
                        data: {
                            speed: newVal.speed
                        }
                    });
                }
                if (newVal.events && newVal.events.length) {
                    var _$ref;
                    var getEventTime = function(val) {
                        if (typeof val === "number") {
                            return val;
                        }
                        return val && val.time;
                    };
                    (_$ref = newVal.events) === null || _$ref === void 0 ? void 0 : _$ref.forEach(function(evt, index) {
                        if (evt && evt.time !== getEventTime(oldVal.events[index])) {
                            postMessage({
                                type: ModelEditorProtocolDataType.animationEventChangedEvent,
                                data: {
                                    index: index,
                                    time: evt.time
                                }
                            });
                        }
                    });
                }
                if (typeof newVal.rotate !== "undefined" && newVal.rotate !== oldVal.rotate) {
                    var originRotate = getAnimationOriginRotateByPath(category.value, animationPath.value);
                    if (isPathInReplacementState(animationPath.value)) {
                        originRotate = 0;
                    }
                    var diff = getAnimationRotateDiff(originRotate, newVal.rotate);
                    changeAnimationRotation(diff);
                }
                var targetIndex = modelAnimationList.value.findIndex(function(item) {
                    return item.file_path === animationPath.value;
                });
                store.commit("creative/modelEditor/setModelAnimationListByIndex", {
                    index: targetIndex,
                    data: newVal
                });
            }
        }, {
            deep: true,
            immediate: false
        });
        watch(function() {
            return JSON.stringify(hsvModel.value);
        }, function(newModel, oldModel) {
            if (newModel !== oldModel) {
                var newVal = JSON.parse(newModel);
                var oldVal = JSON.parse(oldModel);
                newVal.forEach(function(v, i) {
                    var indexHsv = null;
                    var value = 0;
                    if (v.hub !== oldVal[i].hub) {
                        indexHsv = HSVValueType.Hue;
                        value = v.hub;
                        postMessage({
                            type: ModelEditorProtocolDataType.hsvType,
                            data: {
                                indexPart: i,
                                indexHsv: indexHsv,
                                value: value
                            }
                        });
                    }
                    if (v.saturation !== oldVal[i].saturation) {
                        indexHsv = HSVValueType.Saturation;
                        value = v.saturation;
                        postMessage({
                            type: ModelEditorProtocolDataType.hsvType,
                            data: {
                                indexPart: i,
                                indexHsv: indexHsv,
                                value: value
                            }
                        });
                    }
                    if (v.value !== oldVal[i].value) {
                        indexHsv = HSVValueType.Brightness;
                        value = v.value;
                        postMessage({
                            type: ModelEditorProtocolDataType.hsvType,
                            data: {
                                indexPart: i,
                                indexHsv: indexHsv,
                                value: value
                            }
                        });
                    }
                });
            }
        }, {
            deep: true,
            immediate: false
        });
        watch(function() {
            return JSON.stringify(storeBasicModel.value);
        }, function(newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }
            var newVal = JSON.parse(newValue);
            var oldVal = JSON.parse(oldValue);
            Object.keys(newVal).forEach(function(key) {
                var k = key;
                if (newVal[k] !== oldVal[k]) {
                    var _$ref = getTransformtypeByKey(k), transformType = _$ref.transformType, vectorKey = _$ref.vectorKey;
                    postMessage({
                        type: ModelEditorProtocolDataType.transformType,
                        data: {
                            transformType: transformType,
                            vectorKey: vectorKey,
                            value: newVal[k]
                        }
                    });
                }
            });
        }, {
            deep: true,
            immediate: false
        });
        watch(function() {
            return JSON.stringify(shaderModel.value);
        }, function(newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }
            var newVal = JSON.parse(newValue);
            var oldVal = JSON.parse(oldValue);
            Object.keys(newVal).forEach(function(key) {
                var k = key;
                if (!_.isEqual(newVal[k], oldVal[k])) {
                    postMessage({
                        type: ModelEditorProtocolDataType.shaderParam,
                        data: {
                            key: k,
                            value: newVal[k]
                        }
                    });
                }
            });
        }, {
            deep: true,
            immediate: false
        });
        var currentResource = computed(function() {
            return resource1.value[category.value.id][0];
        });
        // 赋值 modelId 和 materialId
        watch(function() {
            return modelId.value;
        }, function(value) {
            if (value) {
                if (!category.value.properties) {
                    category.value.properties = {};
                }
                category.value.properties.modelId = value;
            }
        });
        // 赋值 modelId 和 materialId
        watch(function() {
            return materialId.value;
        }, function(value) {
            if (value) {
                var materialList = updateMaterialListByConfig({
                    modelMaterialList: modelMaterialList.value,
                    category: category.value,
                    resource: resource1.value,
                    materialId: materialId.value,
                    materialPath: materialPath.value
                });
                store.commit("creative/modelEditor/setModelMaterialList", materialList);
            }
        });
        var template = computed(function() {
            return store.state.creative.template;
        });
        var handleSave = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var textureData, animationData, modelData, changeRotationList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item1, targetCategory, targetResource, resInfo, modelInfo, modelPath, res1;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            submitLoading.value = true;
                            store.dispatch("creative/modelEditor/syncStoreToModelModifyConfig");
                            if (replaceData.value.length) {
                                textureData = replaceData.value.filter(function(data) {
                                    return data.prefix && isTexturePrefix(data.prefix);
                                });
                                animationData = replaceData.value.filter(function(data) {
                                    return data.prefix && isAnimationPrefix(data.prefix);
                                });
                                modelData = replaceData.value.filter(function(data) {
                                    return !data.prefix;
                                });
                                if (modelData.length) {
                                    updateResource({
                                        file: {
                                            file_path: currentResource.value.file_path,
                                            origin_name: currentResource.value.file_name,
                                            convertFiles: modelData.map(function(i) {
                                                return i.value;
                                            })
                                        }
                                    });
                                }
                                if (textureData.length && textureResourceList.value.length) {
                                    textureData.forEach(function(data) {
                                        var texRes;
                                        _.each(resource1.value, function(val) {
                                            if (val.some(function(res) {
                                                return res.prefix === data.prefix;
                                            })) {
                                                texRes = val.find(function(res) {
                                                    return res.prefix === data.prefix;
                                                });
                                            }
                                        });
                                        if (texRes) {
                                            store.dispatch("creative/template/updateResource", _objectSpreadProps(_objectSpread({}, texRes), {
                                                file_path: data.file
                                            }));
                                        }
                                    });
                                }
                                if (animationData.length && cocosActionResourceList.value.length) {
                                    animationData.forEach(function(data) {
                                        cocosActionResourceList.value.forEach(function(res) {
                                            var currentMap = replaceMap.value[res.category_id];
                                            if (res.prefix === data.prefix) {
                                                if (currentMap && currentMap.thumbUrl) {
                                                    res.extra = _objectSpreadProps(_objectSpread({}, res.extra), {
                                                        thumb_url: currentMap.thumbUrl
                                                    });
                                                }
                                                store.dispatch("creative/template/updateResource", _objectSpreadProps(_objectSpread({}, res), {
                                                    preview_urls: [
                                                        data.value
                                                    ],
                                                    res_id: currentMap && currentMap.resId,
                                                    res_source: currentMap && currentMap.resSource || "common"
                                                }));
                                            }
                                        });
                                    });
                                }
                            }
                            // 由于动作替换以及删除的时候，需要删除 modifyConfig 里面的数据
                            if (getAnimationList(category.value).length) {
                                getAnimationList(category.value).forEach(function(item) {
                                    // 只有绑定的模型只有一个的时候可以删除，如果绑定了多个模型的动作，不允许删除
                                    if (!modelAnimationList.value.some(function(i) {
                                        return i.id === item.id;
                                    }) && item.model_category_ids.length === 1) {
                                        store.commit("creative/modelEditor/deleteAnimationConfigById", item.id);
                                    }
                                });
                            }
                            changeRotationList = [];
                            modelAnimationList.value.forEach(function(item) {
                                var originRotate = getAnimationOriginRotateByPath(category.value, item.file_path);
                                if (isPathInReplacementState(item.file_path)) {
                                    originRotate = 0;
                                }
                                if (!originRotate && item.rotate || originRotate && originRotate !== item.rotate) {
                                    changeRotationList.push(_objectSpreadProps(_objectSpread({}, item), {
                                        rotate: item.rotate
                                    }));
                                }
                            });
                            if (!changeRotationList.length) {
                                _ctx.next = 50;
                                break;
                            }
                            store.commit("creative/modelEditor/setModelLoading", true);
                            _ctx.prev = 8;
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _ctx.prev = 10;
                            _iterator = changeRotationList[Symbol.iterator]();
                        case 12:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _ctx.next = 30;
                                break;
                            }
                            item1 = _step.value;
                            targetCategory = useIdToFindCategory({
                                category: templateCategory.value,
                                categoryId: item1.category_id
                            });
                            targetResource = resource1.value[item1.category_id][0];
                            resInfo = {};
                            if (targetResource.res_id) {
                                resInfo.id = targetResource.res_id;
                            } else {
                                resInfo.name = targetResource.prefix;
                            }
                            _ctx.next = 20;
                            return getCommonAssetModelInfo(resInfo);
                        case 20:
                            modelInfo = _ctx.sent;
                            modelPath = _.get(modelInfo, "data.data.file_url");
                            _ctx.next = 24;
                            return store.dispatch("creative/template/model/convertCocosModel", {
                                file_url: modelPath,
                                mod: "gm",
                                model: getJsonModelPath(targetResource.file_path),
                                tpl_id: template.value.templateId,
                                preset: isPresetPrefix(targetCategory.prefix) ? 1 : 0,
                                rotate: item1.rotate
                            });
                        case 24:
                            res1 = _ctx.sent;
                            console.log("res", res1);
                            store.dispatch("creative/template/updateResource", _objectSpreadProps(_objectSpread({}, targetResource), {
                                preview_urls: res1.data.data.files
                            }));
                        case 27:
                            _iteratorNormalCompletion = true;
                            _ctx.next = 12;
                            break;
                        case 30:
                            _ctx.next = 36;
                            break;
                        case 32:
                            _ctx.prev = 32;
                            _ctx.t0 = _ctx["catch"](10);
                            _didIteratorError = true;
                            _iteratorError = _ctx.t0;
                        case 36:
                            _ctx.prev = 36;
                            _ctx.prev = 37;
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        case 39:
                            _ctx.prev = 39;
                            if (!_didIteratorError) {
                                _ctx.next = 42;
                                break;
                            }
                            throw _iteratorError;
                        case 42:
                            return _ctx.finish(39);
                        case 43:
                            return _ctx.finish(36);
                        case 44:
                            _ctx.next = 50;
                            break;
                        case 46:
                            _ctx.prev = 46;
                            _ctx.t1 = _ctx["catch"](8);
                            console.error(_ctx.t1);
                            store.commit("creative/modelEditor/setModelLoading", false);
                        case 50:
                            syncModelAnimationListToTemplateCategory({
                                modelAnimationList: modelAnimationList.value,
                                modelCategory: category.value,
                                templateCategory: templateCategory.value
                            });
                            syncModelMaterialListToCategory({
                                modelMaterialList: modelMaterialList.value,
                                category: category.value
                            });
                            _ctx.next = 54;
                            return store.dispatch("creative/template/saveTemplate");
                        case 54:
                            store.commit("creative/modelEditor/setModelLoading", false);
                            submitLoading.value = false;
                            visible.value = false;
                        case 57:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        8,
                        46
                    ],
                    [
                        10,
                        32,
                        36,
                        44
                    ],
                    [
                        37,
                        ,
                        39,
                        43
                    ]
                ]);
            }));
            return function handleSave() {
                return _ref.apply(this, arguments);
            };
        }();
        var tab = computed(function() {
            var tabTemp = [];
            // 有模型 id 代表可以编辑几何信息
            if (modelId.value) {
                tabTemp.push({
                    label: root.$t("playTurbo.custom.modelEdit.basic.title"),
                    value: TabType.Basic
                });
            }
            if (modelMaterialList.value && modelMaterialList.value.length) {
                var _tabTemp;
                (_tabTemp = tabTemp).push.apply(_tabTemp, _toConsumableArray(modelMaterialList.value.filter(function(item) {
                    // 避免没有 材质 id 的皮肤展示，展示也没意义
                    return !(isFeModelId(item.id) && item.is_default);
                }).map(function(item) {
                    return {
                        label: language.get() === "en" ? item.name_en : item.name,
                        value: "".concat(TabType.Appearance).concat(item.shader_file_path)
                    };
                })));
            }
            if (isMaterialWarehouse() || modelAnimationList.value.length) {
                tabTemp.push({
                    label: root.$t("playTurbo.custom.modelEdit.action.title"),
                    value: TabType.Animation
                });
            }
            return tabTemp;
        });
        var notResult = computed(function() {
            return !modelId.value && !materialId.value;
        });
        watch(function() {
            return activeTab.value;
        }, function(value) {
            if (value === TabType.Animation) {
                store.dispatch("creative/modelEditor/syncStoreToModelModifyConfig");
                showAnimationView();
            } else {
                closeAnimationView();
            }
            if (value === TabType.Basic) {
                store.commit("creative/modelEditor/setAnimationPath", "");
            } else if (value === TabType.Animation) {
                if (modelAnimationList.value && modelAnimationList.value.length) {
                    var animationFilePath = modelAnimationList.value[0].file_path;
                    store.commit("creative/modelEditor/setAnimationPath", animationFilePath);
                }
            } else if (value.includes(TabType.Appearance)) {
                store.commit("creative/modelEditor/setAnimationPath", "");
                var shaderFilePath = value.replace(TabType.Appearance, "");
                store.commit("creative/modelEditor/setMaterialPath", shaderFilePath);
            }
        });
        var closeDialog = function() {
            // 重置动画数据
            if (animationForm.value && animationForm.value[0] && animationForm.value[0].rollbackAll) {
                animationForm.value[0].rollbackAll();
            }
            // 点击取消，回滚到 jsonConfig 的状态
            store.dispatch("creative/modelEditor/syncJsonConfigToModelModifyConfig");
            store.commit("creative/asset/updateResourceManagerDialog", {
                visible: false
            });
            visible.value = false;
        };
        var modelLoading = computed(function() {
            return store.state.creative.modelEditor.modelLoading;
        });
        var dialogConfig = reactive({
            visible: false,
            loading: false,
            width: "500px",
            title: "\u65B0\u589E\u76AE\u80A4",
            labelPosition: "left",
            deleteLabel: "\u5220\u9664\u76AE\u80A4"
        });
        var dialogValue = ref({});
        var handleTabsEdit = function(targetName, action) {
            // 如果是删除，即是编辑
            if (action === "remove") {
                if (targetName === TabType.Basic || targetName === TabType.Animation) {
                    return;
                }
                dialogConfig.title = "\u7F16\u8F91\u76AE\u80A4";
                dialogConfig.deleteLabel = "\u5220\u9664\u76AE\u80A4";
                dialogValue.value = _.cloneDeep(modelMaterialList.value.find(function(item) {
                    return "".concat(TabType.Appearance).concat(item.shader_file_path) === targetName;
                }));
            } else {
                dialogConfig.title = "\u65B0\u589E\u76AE\u80A4";
                dialogConfig.deleteLabel = "";
                dialogValue.value = getMaterialListByDefault(modelMaterialList.value.length);
            }
            dialogConfig.visible = true;
        };
        var tabEditable = computed(function() {
            return Boolean(isMaterialWarehouse());
        });
        return {
            visible: visible,
            handleSave: handleSave,
            iframeUrl: iframeUrl,
            tab: tab,
            activeTab: activeTab,
            loading: loading,
            iframeRef: iframeRef,
            currentResource: currentResource,
            category: category,
            closeDialog: closeDialog,
            modelLoading: modelLoading,
            notResult: notResult,
            textureResourceList: textureResourceList,
            handleTabsEdit: handleTabsEdit,
            tabEditable: tabEditable,
            dialogConfig: dialogConfig,
            modelMaterialList: modelMaterialList,
            dialogValue: dialogValue,
            submitCallback: submitCallback,
            targetModelMaterial: targetModelMaterial,
            cocosActionResourceList: cocosActionResourceList,
            modelAnimationList: modelAnimationList,
            TabType: TabType,
            animationForm: animationForm,
            submitLoading: submitLoading,
            animationId: animationId
        };
    }
});
